import { useQuery } from '@tanstack/react-query';
import { getHttpServiceWithOptions } from '../../../domain/http/http.factory';
import { AUTH_CLIENT_ID } from '../../../domain/auth/auth-constants';
import { useCore } from '../../../feature/context/core.context';

export const useConnectedUserInfo = ({
  doNotShowConnectedUserInfoModalAgain,
}: {
  doNotShowConnectedUserInfoModalAgain: boolean | undefined;
}) => {
  const { auth } = useCore();
  const connectedUserInfo = useQuery(
    ['CONNECTED', 'USER_INFO'],
    () => {
      if (process.env.NEXT_PUBLIC_WARP_AUTH_ENABLED) {
        return getHttpServiceWithOptions(process.env.NEXT_PUBLIC_WARP_BASE_URL, true).get('', {
          headers: {
            'x-absolute-api-url': `${process.env.NEXT_PUBLIC_CONNECTED_BASE_URL_API}/v2/user/info`,
            'x-client-id': AUTH_CLIENT_ID,
          },
        });
      } else {
        return getHttpServiceWithOptions(process.env.NEXT_PUBLIC_CONNECTED_BASE_URL_API, false).get('/v2/user/info');
      }
    },
    {
      enabled: doNotShowConnectedUserInfoModalAgain === false && auth.isAuthenticated,
      retry: (failureCount, error: any) => {
        if (error?.response?.status === 404 || error?.response?.status === 500) {
          return false;
        }
        return failureCount < 3;
      },
    }
  );

  return {
    connectedUserInfo,
  };
};
